export default {
  "pl": {
    "phase": {
      "attributes": {
        "end_date": "Data ukończenia",
        "internal_note": "Notatka do użytku wewnętrznego",
        "name": "Nazwa",
        "start_date": "Data rozpoczęcia"
      },
      "labels": {
        "phase": "Brak fazy | 1 faza | Liczba faz: {count}"
      },
      "toasts": {
        "create": "Utworzono fazę",
        "delete": "Usunięto fazę",
        "update": "Zaktualizowano fazę"
      },
      "validation": {
        "needName": "Należy podać tytuł",
        "needNumber": "Należy podać liczbę (np. 85)"
      }
    }
  }
}
